import { themeObject } from 'lib';

export const headerTemplateStyles = {
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    headerDetailsStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '50%',
        gap: 1,
        '& .MuiBox-root': {
            '& .MuiTypography-root': {
                '& .MuiBreadcrumbs-ol': {
                    justifyContent: 'flex-start',
                },
            },
        },
    },
    headingTextStyles: {
        ...themeObject.typography.h2,
        fontWeight: 600,
        color: themeObject.palette.primary[700],
        fontVariantNumeric: 'lining-nums',
    },
    breadcrumbsContainer: {
        width: '100%',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    textButtonStyles: {
        backgroundColor: themeObject.palette.grayScale[50],
    },
    saveAndCloseButtonStyles: {
        minWidth: '130px',
    },
    unsavedChangesTextStyles: {
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.medium,
        lineHeight: '15.88px',
        color: themeObject.palette.error[600],
    },
    dividerStyles: {
        color: themeObject.palette.grayScale[200],
    },
    menuItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    menuItemTextStyles: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
    },
};
